import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_DEACTIVATE_REQUEST,
  CONFIDENTIAL_DEACTIVATE_SUCCESS,
  CONFIDENTIAL_DEACTIVATE_FAILURE,
  CONFIDENTIAL_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case CONFIDENTIAL_DEACTIVATE_SUCCESS:
      return state
        .set('confidentialDeactivate', fromJS(action.payload.deleteEmployeeConfidential))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case CONFIDENTIAL_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('confidentialDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CONFIDENTIAL_DEACTIVATE_RESET:
      return state
        .delete('confidentialDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-deactivate-reducer.js